module.exports = __webpack_public_path__ + "img/portfolio-9.70fae66f.jpg";